// @flow

import { PureComponent } from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import DisplayText from './Text/DisplayText';

const DEFAULT_SIZE = '60px';

const AvatarContainer = styled.div`
  display: flex;
  height: ${props => props.size};
  width: ${props => props.size};
  border-radius: 50%;
  border: 2px solid ${props => props.theme.avatarBorderColor};
  background-color: ${props => props.theme.avatarDefaultBg};
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const AvatarImg = styled.img`
  object-fit: cover;
  width: 100%;
  border-radius: 50%;
  height: ${props => props.size};
  width: ${props => props.size};
`;

type Props = {
  avatar?: string,
  name?: string,
  lastName?: string,
  label?: string,
  size: string
};

type State = {
  avatar: string
};

export default class Avatar extends PureComponent<Props, State> {
  static defaultProps = {
    size: DEFAULT_SIZE,
    avatar: '',
    name: '',
    lastname: '',
    label: ''
  };

  componentDidMount() {
    this.setState({ avatar: this.props.avatar });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ avatar }: Props) {
    if (avatar !== this.props.avatar) {
      this.setState({ avatar });
    }
  }

  state = {
    avatar: ''
  };

  clearAvatar = () => {
    this.setState({ avatar: '' });
  };

  getAvatarText(): string {
    if (this.props.label) {
      return this.props.label;
    }

    const name: string = get(this, 'props.name[0]', '');
    const lastName: string = get(this, 'props.lastname[0]', '');
    return `${name}${lastName}`.toUpperCase();
  }

  render() {
    return (
      <AvatarContainer size={this.props.size}>
        {!!this.state.avatar && (
          <AvatarImg src={this.state.avatar} onError={this.clearAvatar} size={this.props.size} />
        )}
        {!this.state.avatar && <DisplayText fontSize="32px">{this.getAvatarText()}</DisplayText>}
      </AvatarContainer>
    );
  }
}

Avatar.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  lastName: PropTypes.string
};
